import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import env from 'config'

// Invite and claim links belong to the web app; superadmin only forwards them (path, query
// and hash intact) and never reads their ?token=.
function WebAppRedirect() {
  const location = useLocation()
  const target = `${env.APP_URL}${location.pathname}${location.search}${location.hash}`
  const sameOrigin = new URL(target, window.location.href).origin === window.location.origin

  useEffect(() => {
    if (!sameOrigin) window.location.replace(target)
  }, [sameOrigin, target])

  return (
    <div className='tw-w-full tw-h-[100vh] tw-flex tw-items-center tw-justify-center tw-p-5'>
      {sameOrigin ? (
        <p>This link opens in the LoyalIdeas web app. Set REACT_APP_APP_URL to the web app URL.</p>
      ) : (
        <p>
          Redirecting to <a href={target}>the LoyalIdeas web app</a>…
        </p>
      )}
    </div>
  )
}

export default WebAppRedirect
